'use strict';

exports.__esModule = true;
exports.injectTypographyStyles = exports.elements = exports.body = exports.html = exports.p = exports.small = exports.headings = exports.h5 = exports.h4 = exports.h3 = exports.h2 = exports.h1 = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteralLoose(['\n  ', '\n'], ['\n  ', '\n']);

var _styledComponents = require('styled-components');

var _etc2 = require('./_etc');

var _etc3 = _interopRequireDefault(_etc2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var h1 = exports.h1 = {
  color: _etc3.default.fontColorDarkGray,
  fontSize: _etc3.default.extraLargeEm,
  fontWeight: _etc3.default.fontWeightBold,
  letterSpacing: _etc3.default.halfLetterSpacing,
  lineHeight: _etc3.default.largeLineHeight,
  textTransform: _etc3.default.textCase
};

var h2 = exports.h2 = {
  color: _etc3.default.fontColorDarkGray,
  fontSize: _etc3.default.largeEm,
  fontWeight: _etc3.default.fontWeightBold,
  letterSpacing: _etc3.default.halfLetterSpacing,
  lineHeight: _etc3.default.largeLineHeight,
  textTransform: _etc3.default.textCase
};

var h3 = exports.h3 = {
  color: _etc3.default.fontColorDarkGray,
  fontSize: _etc3.default.mediumEm,
  fontWeight: _etc3.default.fontWeightBold,
  letterSpacing: _etc3.default.halfLetterSpacing,
  lineHeight: _etc3.default.baseLineHeight,
  textTransform: _etc3.default.textCase
};

var h4 = exports.h4 = {
  color: _etc3.default.fontColorDarkGray,
  fontSize: _etc3.default.smallEm,
  fontWeight: _etc3.default.fontWeightBold,
  letterSpacing: _etc3.default.halfLetterSpacing,
  lineHeight: _etc3.default.smallLineHeight
};

var h5 = exports.h5 = {
  color: _etc3.default.fontColorGray,
  fontSize: _etc3.default.extraSmallEm,
  fontWeight: _etc3.default.fontWeightSemibold,
  letterSpacing: _etc3.default.halfLetterSpacing,
  lineHeight: _etc3.default.extraSmallLineHeight,
  textTransform: _etc3.default.textCase
};

var headings = exports.headings = { h1: h1, h2: h2, h3: h3, h4: h4, h5: h5 };

var small = exports.small = {
  color: _etc3.default.fontColorGray,
  fontSize: _etc3.default.smallTagEm,
  fontWeight: _etc3.default.fontWeightNormal,
  letterSpacing: _etc3.default.baseLetterSpacing,
  lineHeight: _etc3.default.baseLineHeight
};

var p = exports.p = {
  color: _etc3.default.fontColorGray,
  fontSize: _etc3.default.paragraphEm,
  fontWeight: _etc3.default.fontWeightNormal,
  letterSpacing: _etc3.default.baseLetterSpacing,
  lineHeight: _etc3.default.baseLineHeight
};

var html = exports.html = { fontSize: _etc3.default.htmlBaseFontSize };

var body = exports.body = {
  color: _etc3.default.fontColorGray,
  fontFamily: _etc3.default.fontFamily,
  fontSize: _etc3.default.bodyBaseFontSize,
  fontWeight: _etc3.default.fontWeightNormal,
  letterSpacing: _etc3.default.baseLetterSpacing,
  lineHeight: _etc3.default.baseLineHeight
};

var elements = exports.elements = _extends({ html: html, body: body, small: small, p: p }, headings);

var injectTypographyStyles = exports.injectTypographyStyles = function injectTypographyStyles() {
  return (0, _styledComponents.injectGlobal)(_templateObject, elements);
};


//////////////////
// WEBPACK FOOTER
// ./~/li-components/lib/styles/js/typography.js
// module id = 2301
// module chunks = 14